import {loadStripe} from "@stripe/stripe-js/pure";

let Account = {
    init: function () {
        this.bind();
    },

    bind: function () {
        if ($('#avatarForm').length) {
            this.avatar();
        }

        if ($('#creditCardForm').length) {
            this.initializeStripe().then(() => {
                this.processCreditCardForm();
                this.initializeLoader();
            });
        }

        this.defaultPaymentMethod();
    },

    avatar() {
        $(document).on('change', '#avatar', () => {
            $('#avatarForm').submit();
        });
    },

    initializeLoader() {
        // this.loader = Ladda.create(document.querySelector('#submit'));
    },

    async initializeStripe() {
        this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
        let elements = this.stripe.elements();
        let style = {
            base: {
                color: "#5c6873",
                fontSize: "0.9rem",
            }
        };

        this.card = elements.create("card", {style: style, class: 'asd', hidePostalCode: true});
        this.card.mount("#card-element");

        this.card.addEventListener('change', ({error}) => {
            const displayError = document.getElementById('card-errors');
            if (error) {
                displayError.textContent = error.message;
            } else {
                displayError.textContent = '';
            }
        });
    },

    processCreditCardForm() {
        let _this = this;
        const form = document.getElementById('creditCardForm');

        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            // _this.loader.start();

            const clientSecret = $('#card-submit').data('secret');
            const card = _this.card;
            const cardholderName = $('#cardholderName').val();

            const { setupIntent, error } = await _this.stripe.confirmCardSetup(
                clientSecret, {
                    payment_method: {
                        card: card,
                        billing_details: { name: cardholderName }
                    }
                }
            );

            if (error) {
                // Display "error.message" to the user...
                toastr.error(error.message);
            } else {
                // The card has been verified successfully...
                $('#paymentMethod').val(setupIntent.payment_method);
                this.submit();
            }
        });
    },

    async validate() {
    },

    defaultPaymentMethod() {
        $(document).on('change', '[name=default_payment_method]', function () {
            const paymentMethod = $(this).val();

            $.post('/user/credit-card', {
                _method: 'PATCH',
                payment_method: paymentMethod,
            }, function (response) {

            });
        });
    },
};


$().ready(() => {
    window.Frontend.Account = Account;
    window.Frontend.Account.init();
});
